








































































import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import { billingTypeValues, payerTypeValues } from '@/modules/Policy/helpers/policy'
import dollarFilter from '@/utils/dollarFilter'
import { IPolicyPremiumInput } from '@/modules/Policy/interfaces/policy-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class PolicyFormPremium extends mixins(SearchPolicy) {
  @Prop({ type: Object as () => IPolicyPremiumInput }) value!: IPolicyPremiumInput

  billingTypeOptions = billingTypeValues
  payerTypeOptions = payerTypeValues

  get totalTermAmount () {
    const {
      premium, agencyFee, carrierPolicyFee, inspectionFee,
      stampingFee, taxesFee, brokerFee
    } = this.value
    const total = (+premium) +
      (+agencyFee) +
      (+carrierPolicyFee) +
      (+inspectionFee) +
      (+stampingFee) +
      (+taxesFee) +
      (+brokerFee)

    return isNaN(total) ? '0.00' : total.toFixed(2)
  }

  get totalProjectedCommission () {
    const { commission, premium } = this.value

    const total = (+premium) * (+commission) / 100

    return isNaN(total) ? '0.00' : total.toFixed(2)
  }

  dollarFilter = dollarFilter

  @Watch('value.effectiveDate')
  onPolicyExffectiveDateChanged (val: string) {
    const { term } = this.value
    if (term) {
      this.value.expirationDate = this.$moment.unix(Number(val)).add(term, 'M').unix()
    }
    this.value.bindDate = val
  }

  @Watch('value.term')
  onPolicyTermDateChanged (val: string) {
    const { effectiveDate } = this.value
    if (effectiveDate) {
      this.value.expirationDate = this.$moment.unix(Number(effectiveDate)).add(val, 'M').unix()
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
